import { GetPersistedResultsDocument, GetPersistedResultsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type PersistedResult =
  GetPersistedResultsQuery['payroll']['employeeResultsSummariesConnection']['nodes'][number]

export const useGetPersistedResults = (policyPeriodId: number) => {
  const { loading, data, refetch } = useQuery(GetPersistedResultsDocument, {
    variables: {
      policyPeriodId: policyPeriodId,
    },
  })

  return {
    loading,
    data: data ? data.payroll.employeeResultsSummariesConnection.nodes : [],
    refetch,
  }
}
